// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wordcloud-view {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 16px;
  position: relative;
}
.wordcloud-view .wordcloud-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wordcloud-view .wordcloud-box > div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wordcloud-view .wordcloud-box svg {
  max-width: 100%;
  max-height: 100%;
  width: auto !important;
  height: auto !important;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/WordCloudView.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAN","sourcesContent":[".wordcloud-view {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  padding: 16px;\r\n  position: relative;\r\n\r\n  .wordcloud-box {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    > div {\r\n      width: 100%;\r\n      height: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n\r\n    svg {\r\n      max-width: 100%;\r\n      max-height: 100%;\r\n      width: auto !important;\r\n      height: auto !important;\r\n      object-fit: contain;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
